<template>
  <div class="services">
    <h2>Services</h2>
    <Carousel
      :data="services"
      :pageDots="true"
      class="carousel"
      selectColour="white"
    />
    <div class="grid">
      <div v-for="(service, index) in services" :key="index" class="grid-item">
        <img :src="service.icon" alt="an icon" />
        <p class="subheading">{{ service.subheading }}</p>
        <span class="desc">{{ service.desc }}</span>
      </div>
    </div>
    <span id="rates"
      >Starting rate of £50 p/hour, depending on services needed. If you are a
      charity or NFP organization, please contact me to discuss pricing.
    </span>
  </div>
</template>

<script>
import Carousel from "../Carousel.vue";
export default {
  components: {
    Carousel,
  },
  data() {
    return {
      services: [
        {
          icon: require("@/assets/icons/SEO.webp"),
          subheading: "Search Engine Optimisation",
          desc: "Optimise your website, social media and ads to make sure your business is found when others search for you.",
        },
        {
          icon: require("@/assets/icons/SocialMediaMarketing.webp"),
          subheading: "Social Media Marketing",
          desc: "Develop and deliver a tailored marketing strategy whether its for Instagram, TikTok, LinkedIn, Facebook or YouTube.",
        },
        {
          icon: require("@/assets/icons/Copywriting.webp"),
          subheading: "Copywriting",
          desc: "Getting to grips with your brand, mimicking your brand voice to easily create captions, blogs and content that captures your audience whatever the media form. ",
        },
        {
          icon: require("@/assets/icons/Blog.webp"),
          subheading: "Meta Ads",
          desc: "Strategise and execute targeted paid advertising campaigns designed to capture attention, expand your social media reach, and strengthen brand visibility. From campaign planning to ad creation and publishing, all while delivering clear data and performance metrics to keep your growth measurable and transparent.",
        },
        {
          icon: require("@/assets/icons/SocialMediaAds.webp"),
          subheading: "Website Management",
          desc: "From maintaining functionality and security to refreshing content and optimising for SEO, I provide end-to-end website management across platforms like WordPress, GoDaddy, and other templated systems. By monitoring performance, implementing strategic improvements, and aligning your website with wider marketing objectives, I help businesses transform their online presence into a powerful driver of growth.",
        },
        {
          icon: require("@/assets/icons/SMSMarketing.webp"),
          subheading: "SMS and Email Marketing",
          desc: "Enhance your customer communication with a blend of manual and automated SMS and email campaigns powered by leading CRM systems such as MailChimp and GoHighLevel. From designing newsletters and promotional campaigns to building intelligent workflows and automated lead response systems, I ensure every message is timely, personalised, and strategically aligned to drive engagement and conversions.",
        },
        {
          icon: require("@/assets/icons/PressRelease.webp"),
          subheading: "PR",
          desc: "Craft and distribute professional press releases that capture your brand’s key messages and share your business news with targeted media outlets. From writing compelling copy to managing distribution, I help position your business in front of the right audiences to increase visibility, credibility, and brand authority.",
        },
        {
          icon: require("@/assets/icons/PodcastIcon.webp"),
          subheading: "Content Creation",
          desc: "Bring your brand to life with content tailored to engage and inspire your audience. From capturing and producing video, audio, graphics, and photography to professional editing and optimisation, I deliver content that aligns with your brand voice and marketing strategy. Whether it’s social media visuals, promotional videos, podcasts, or branded imagery, every piece is designed to enhance your online presence and drive measurable results.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.services {
  margin-top: 0;
  background: #258675;
  padding: 50px 150px 150px 150px;
}

#rates {
  display: block;
  text-align: center;
  font-style: italic;
  font-size: 14px;
  width: 100%;
  color: white;
  padding: 50px 0 0 0;
}

h2 {
  font-size: 50px;
  font-weight: 700;
  color: white;
  text-align: center;
}

.carousel {
  display: none;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 20px;

  .subheading {
    color: white;
    font-size: 20px;
    font-weight: 700;
  }

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: white;
  }
}

.grid-item {
  width: 100%;
}

@media (max-width: 768px) {
  h2 {
    font-size: 40px;
  }
  .grid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);
  }
  #rates {
    font-size: 10px;
  }
}

@media (max-width: 600px) {
  .carousel {
    display: block;
  }

  .grid {
    display: none;
  }

  .services {
    padding: 40px 30px;
    text-align: center;
  }
}
</style>
